import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.2927 2.80723C17.3651 2.59507 17.3032 2.35995 17.1347 2.21178C16.5706 1.7137 15.1445 0.664687 13.0034 0.509561C10.6056 0.335653 9.12109 0.978418 8.37119 1.45493C8.04772 1.66014 8.02964 2.12622 8.33224 2.36133L14.4406 7.10904C14.979 7.5271 15.7685 7.2906 15.9884 6.64504L17.2927 2.80723Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.23501 16.8996C1.98528 17.0672 1.87258 17.376 1.95328 17.6661C2.18562 18.5009 2.87778 20.2378 4.84225 21.8184C6.80671 23.3988 9.13083 23.5692 10.1242 23.5449C10.4212 23.538 10.68 23.3425 10.7697 23.0586L14.6854 10.666C14.9679 9.77137 13.9655 9.02079 13.1871 9.5439L2.23501 16.8996Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5.09695 3.8224C4.90495 3.74659 4.69 3.7591 4.50844 3.85789C3.7836 4.25232 1.92765 5.46759 0.970459 7.96421C0.231697 9.88833 0.491863 12.0163 0.694988 13.0569C0.76177 13.3971 1.12072 13.5933 1.44349 13.4674L13.192 8.88036C14.031 8.55271 14.0344 7.36666 13.1969 7.03485L5.09695 3.8224Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5248 12.7026C22.8643 12.9329 23.329 12.7298 23.3881 12.3235C23.5439 11.2481 23.6789 9.37614 23.0563 7.96399C22.2263 6.08231 20.8177 4.92199 20.1493 4.45035C19.9378 4.30149 19.6526 4.31679 19.4585 4.48861L16.4936 7.11811C16.0096 7.54731 16.0597 8.31738 16.5952 8.68119L22.5248 12.7026Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.2409 22.7406C14.2103 23.0905 14.5067 23.3799 14.8559 23.3424C15.9794 23.2219 18.2875 22.7761 20.0168 21.124C21.7003 19.5163 22.2478 17.6076 22.4071 16.8479C22.4501 16.6427 22.3987 16.4292 22.2665 16.2663L17.0827 9.86863C16.5212 9.17578 15.4019 9.51802 15.3241 10.4064L14.2409 22.7406Z"}}]};

const LogoCnbFilled = Vue.extend<IconProps>({
  name: 'LogoCnbFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-cnb-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoCnbFilled;
